(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["far-product-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const thumb = event.target.closest('.far-new-gallery__thumb');
  if (!thumb) return;
  const gallery = thumb.closest('.far-new-gallery');
  gallery.querySelectorAll('.far-new-gallery__thumb').forEach(function (item) { item.classList.remove('is-active'); });
  gallery.querySelectorAll('.far-new-gallery__panel').forEach(function (item) { item.classList.remove('is-active'); });
  thumb.classList.add('is-active');
  const panel = gallery.querySelector('[data-far-panel="' + thumb.dataset.farMedia + '"]');
  if (panel) panel.classList.add('is-active');
});

document.addEventListener('on:variant:change', function (event) {
  const section = event.target.closest('.far-new-product');
  if (!section || !event.detail || !event.detail.variant) return;

  const variant = event.detail.variant;
  const picker = event.target.closest('variant-picker');
  const formatted = picker && picker.data && picker.data.formatted ? picker.data.formatted[variant.id] : null;

  const form = section.querySelector('.js-product-form');
  const variantInput = form && form.querySelector('input[name="id"]');
  if (variantInput) {
    variantInput.value = variant.id;
    variantInput.disabled = false;
  }

  const price = section.querySelector('[data-far-current-price]');
  const stickyPrice = section.querySelector('[data-far-sticky-price]');
  if (formatted && formatted.price) {
    if (price) price.innerHTML = formatted.price;
    if (stickyPrice) stickyPrice.innerHTML = formatted.price;
  }

  const compare = section.querySelector('[data-far-compare-price]');
  const savings = section.querySelector('[data-far-savings]');
  const savingsValue = section.querySelector('[data-far-savings-value]');
  const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
  if (compare) {
    compare.hidden = !isOnSale;
    compare.innerHTML = isOnSale && formatted && formatted.compareAtPrice ? formatted.compareAtPrice : '';
  }
  if (savings) savings.hidden = !isOnSale;
  if (savingsValue) {
    if (isOnSale) {
      const savedCents = variant.compare_at_price - variant.price;
      const locale = document.documentElement.lang && document.documentElement.lang.toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA';
      savingsValue.textContent = new Intl.NumberFormat(locale, {style:'currency', currency:'CAD'}).format(savedCents / 100);
    } else {
      savingsValue.textContent = '';
    }
  }

  const skuLine = section.querySelector('.far-new-product__sku');
  const sku = section.querySelector('[data-far-sku]');
  if (sku) sku.textContent = variant.sku || '';
  if (skuLine) skuLine.hidden = !variant.sku;

  const monthly = section.querySelector('[data-far-monthly]');
  if (monthly) {
    const locale = document.documentElement.lang && document.documentElement.lang.toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA';
    const amount = new Intl.NumberFormat(locale, {style:'currency', currency:'CAD'}).format((variant.price / 100) / 24);
    monthly.textContent = locale === 'fr-CA' ? 'À partir de ' + amount + ' / mois' : 'From ' + amount + ' / month';
  }

  if (variant.featured_media && variant.featured_media.id) {
    const mediaId = String(variant.featured_media.id);
    const gallery = section.querySelector('.far-new-gallery');
    if (gallery) {
      const thumb = gallery.querySelector('[data-far-media="' + mediaId + '"]');
      const panel = gallery.querySelector('[data-far-panel="' + mediaId + '"]');
      if (panel) {
        gallery.querySelectorAll('.far-new-gallery__thumb').forEach(function (item) { item.classList.toggle('is-active', item === thumb); });
        gallery.querySelectorAll('.far-new-gallery__panel').forEach(function (item) { item.classList.toggle('is-active', item === panel); });
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
